import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "actions-toolbar flex-center justify-space-between mt-2" }

import { useI18n } from 'vue-i18n'


export default {
  __name: 'GuestsActionsToolbar',
  emits: ['clear', 'apply'],
  setup(__props) {

const { t } = useI18n()



return (_ctx, _cache) => {
  const _component_v_btn = _resolveComponent("v-btn")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      class: "text-none",
      ripple: false,
      variant: "plain",
      size: "large",
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('clear')), ["prevent"]))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('Search#Form#RoomIndex#Button Clear')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_v_btn, {
      class: "text-none",
      color: "primary",
      ripple: false,
      size: "large",
      variant: "tonal",
      onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('apply')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('Search#Form#Button Apply')), 1)
      ]),
      _: 1
    })
  ]))
}
}

}